import { ImageObject } from "@/modules/images";

// Box Images
import imageBoxEmblem from "@/content/_images/projects/uni-y3-chivas-regal/chivas_box_emblem.jpg";
import imageBoxFront from "@/content/_images/projects/uni-y3-chivas-regal/chivas_box_front.jpg";
import imageBoxLabel from "@/content/_images/projects/uni-y3-chivas-regal/chivas_box_label.jpg";
import imageBoxMotif from "@/content/_images/projects/uni-y3-chivas-regal/chivas_box_motif.jpg";
import imageBoxRear from "@/content/_images/projects/uni-y3-chivas-regal/chivas_box_rear.jpg";
import imageBoxTop from "@/content/_images/projects/uni-y3-chivas-regal/chivas_box_top.jpg";
import imageBoxWindows from "@/content/_images/projects/uni-y3-chivas-regal/chivas_box_windows.jpg";

// Bottle Images
import imageBottleLabel from "@/content/_images/projects/uni-y3-chivas-regal/chivas_bottle_label.jpg";
import imageBottleLarge from "@/content/_images/projects/uni-y3-chivas-regal/chivas_bottle_large.jpg";
import imageBottleTop from "@/content/_images/projects/uni-y3-chivas-regal/chivas_bottle_top.jpg";

const images: ImageObject = {
	"p/chivas-regal/box_emblem": {
		src: imageBoxEmblem,
		alt: "Close-up of the Chivas Regal logo imprinted on a box"
	},
	"p/chivas-regal/box_front": {
		src: imageBoxFront,
		alt: "Front of Chivas Regal Sovereign's Reserve box"
	},
	"p/chivas-regal/box_label": {
		src: imageBoxLabel,
		alt: "Close up Chivas Regal Sovereign's Reserve label on box"
	},
	"p/chivas-regal/box_motif": {
		src: imageBoxMotif,
		alt: "Close-up of Chivas Regal motif on a box"
	},
	"p/chivas-regal/box_rear": {
		src: imageBoxRear,
		alt: "Rear of Chivas Regal Sovereign's Reserve box"
	},
	"p/chivas-regal/box_top": {
		src: imageBoxTop,
		alt: "Top of Chivas Regal Sovereign's Reserve box, showing it's tag-line, 'You're always entitled'"
	},
	"p/chivas-regal/box_windows": {
		src: imageBoxWindows,
		alt: "Side of Chivas Regal Sovereign's Reserve box, showing the windows of Chivas Regal. It's distillery, it's casks and the Scottish Highlands."
	},
	"p/chivas-regal/bottle_label": {
		src: imageBottleLabel,
		alt: "Chivas Regal Sovereign's Reserve label imprinted onto a bottle"
	},
	"p/chivas-regal/bottle_large": {
		src: imageBottleLarge,
		alt: "Chivas Regal bottle"
	},
	"p/chivas-regal/bottle_top": {
		src: imageBottleTop,
		alt: "Top of a Chivas Regal Sovereign's Reserve bottle, showing the Chivas Regal emblem etched into the cork lid."
	}
};

export default images;
